import type { Database } from "../../../__definitions__/database-definitions";
import { SupabaseServiceView } from "../../../server/supabase/base-supabase-service";

export type CommunicationInsightsPageRow =
  Database["public"]["Views"]["communication_insights_page"]["Row"];

export class SupabaseCommunicationInsightsPageService extends SupabaseServiceView<"communication_insights_page"> {
  table = "communication_insights_page" as const;
}
